import { render, staticRenderFns } from "./BadgeDangerousGoods.vue?vue&type=template&id=54efacb0&scoped=true&"
import script from "./BadgeDangerousGoods.vue?vue&type=script&lang=js&"
export * from "./BadgeDangerousGoods.vue?vue&type=script&lang=js&"
import style0 from "./BadgeDangerousGoods.vue?vue&type=style&index=0&id=54efacb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54efacb0",
  null
  
)

export default component.exports